export default "__VITE_ASSET__1fa2a743__"